import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface IInfoModalProps {
  title?: string;
  isModalOpen: boolean;
  handleClose: () => void;
}

const InfoModal: React.FC<IInfoModalProps> = ({
  title,
  isModalOpen,
  handleClose,
}) => {
  return (
    <Dialog open={isModalOpen} onClose={handleClose} maxWidth="md">
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText>
          <Typography variant="h6" component="span">
            The app is currently not mobile optimised, we would advise logging
            in through your desktop
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          style={{ maxHeight: '40px', marginBottom: '5px' }}
          onClick={handleClose}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InfoModal;
